<script setup lang="ts">
import SearchInput from '../sections/SearchInput.vue';
import BetSlip from '../sections/BetSlip.vue';

interface Step {
  placeholder: string;
  ghost: string;
}

defineProps<{
  displayedText: string;
  isTyping: boolean;
  step: Step;
}>();

defineEmits<{
  (e: 'scrollToEditor'): void;
}>();
</script>

<template>
  <div class="step-container">
    <SearchInput 
      :displayedText="displayedText" 
      :isTyping="isTyping"
      :placeholder="step.placeholder"
      :ghost="step.ghost"
    />
    
    <transition name="fade-up">
      <BetSlip 
        v-if="displayedText.toLowerCase() === 'arsenal'"
        type="single"
        @scrollToEditor="$emit('scrollToEditor')"
      />
    </transition>
  </div>
</template>

<style scoped>
.step-container { width: 100%; height: 100%; position: relative; }
.fade-up-enter-active { animation: fadeInUp 0.4s ease; }
.fade-up-leave-active { animation: fadeOutDown 0.3s ease; }
@keyframes fadeInUp { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
@keyframes fadeOutDown { from { opacity: 1; transform: translateY(0); } to { opacity: 0; transform: translateY(10px); } }
</style>
